import React from "react";

const GenericHeader = props => {
    return (
        <>
            <div className="header">
                <img src={props.logo} alt="" />
            </div>
            <div className="subheader">
                <div className="status">Live</div>
            </div>
        </>
    )
}

export default GenericHeader;